/** Checkout and payment processing, but not the success page that follows them. */
const CHECKOUT_PATH = /^\/checkout(\/(?!success)|$)/;

const ERROR_SELECTOR = '[role="alert"], .mat-mdc-form-field-error';

/**
 * Things a prompt must never land on top of: the cookie banner, an open dialog or sheet, an
 * error on screen, or the checkout flow.
 */
const MODAL_SELECTOR = [
    '#CybotCookiebotDialog',
    '.mat-mdc-dialog-container',
    '.mat-bottom-sheet-container'
].join(',');

export function isPageBusy(document: Document): boolean {
    const path = document.defaultView?.location.pathname ?? '';
    const visibleError = Array.from(document.querySelectorAll(ERROR_SELECTOR))
        .some(element => !!element.textContent?.trim());

    return CHECKOUT_PATH.test(path) || visibleError || !!document.querySelector(MODAL_SELECTOR);
}
